import './NewsPage.scss';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, DatePicker, Dropdown, Form, Input, Menu, Upload } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { NewsData } from '../../../models/CommunicationsData';
import { ChangeNewsStatus, CreateNews, deleteNews, EditFeaturedNews, EditNews, fetchLanguagesAvailables, GetNewsData } from '../../../api/repositoryEP';
import { LoadingData } from '../../../components/common';
import { ArrowLeftOutlined, CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, LoadingOutlined, MoreOutlined, PlusOutlined, StarFilled, StarOutlined } from '@ant-design/icons';
import TagStatusNews from '../../../components/news/TagStatusNews';
import { NewStatus } from '../../../utils/constants';

import moment from 'moment';
import { GenericModal } from '../../../components/common/Modal/GenericModal';
import LanguageSelectorNews from '../../../components/common/LanguageSelectorNews/LanguageSelectorNews';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import TinyEditor from '../../../components/common/Editor/TinyEditor';
import { useForm } from 'antd/es/form/Form';
import { useSessionData } from '../../../Contexts/SessionDataContext';


const NewsPage = (): JSX.Element => {
    const { t } = useTranslation();
    const appConfig = useAppConfig();
    const navigate = useNavigate();
    const [newsInfo, setNewsInfo] = useState<NewsData | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [visibleModalDeleteNews, setVisibleModalDeleteNews] = useState(false);
    const [visibleModalUnpublishedNews, setVisibleModalUnpublishedNews] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState<string>("");
    const [isVisibleDraftModal, setIsVisibleDraftModal] = useState<boolean>(false);
    const [isDraftModalFromBack, setIsDraftModalFromBack] = useState<boolean>(false);
    const [isVisibleUnsavedModal, setIsVisibleUnsavedModal] = useState<boolean>(false);
    const [isThereAnyChange, setIsThereAnyChange] = useState<boolean>(false);
    const [form] = useForm();
    const isScheduled = Form.useWatch('isSheduledPublishDate', form);
    const { sessionData } = useSessionData();
    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [availableLanguages, setAvailableLanguages] = useState<string[]>([]);

    const { id } = useParams<{ id: string }>();
    const onEdit = !!id;  // Determina si estÃ¡s en modo ediciÃ³n
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language.split("-")[0].toLowerCase();



    useEffect(() => {
        if (newsInfo && selectedLanguage) {
            const title = newsInfo.titlesByLanguage.find((lang) => lang.key === selectedLanguage)?.value || '';
            form.setFieldValue("title", title);
        }
    }, [newsInfo, selectedLanguage, form]);


    useEffect(() => {
        const initializePage = async () => {
            setIsLoading(true);

            try {
                // Fetch idiomas disponibles
                const languagesResponse = await fetchLanguagesAvailables("wa", false);
                const languages = languagesResponse?.type === 1 && Array.isArray(languagesResponse.data) ? languagesResponse.data : [];


                let selectedLang = languages[0];

                if (languages.length > 0) {

                    selectedLang =
                        languages.find(
                            l => l.split("-")[0].toLowerCase() === i18n.language.toLowerCase()
                        ) ?? languages[0];

                    setAvailableLanguages(languages);
                    setSelectedLanguage(selectedLang);
                }



                // Fetch datos de la noticia
                if (onEdit) {
                    const response = await GetNewsData(id!);
                    let data: NewsData = response?.data;


                    if (data) {
                        setNewsInfo(data);
                        setImageForUpload(data.img)
                        const nameImage = data.img.split('/').pop();



                        // AsegÃºrate de que Moment sepa que la fecha es UTC
                        const localDateFrom = data.sheduleDayFrom
                            ? moment.utc(data.sheduleDayFrom, "YYYY-MM-DDTHH:mm:ss").local()
                            : null;

                        const localDateTo = data.sheduleDayTo
                            ? moment.utc(data.sheduleDayTo, "YYYY-MM-DDTHH:mm:ss").local()
                            : null;







                        // Establecer valores iniciales del formulario
                        form.setFieldsValue({
                            sheduledPublishDateFrom: localDateFrom,
                            sheduledPublishDateTo: localDateTo,
                            title: data.titlesByLanguage.find((lang) => lang.key === selectedLang)?.value || '',
                            uploadFile: nameImage,
                            isSheduledPublishDate: localDateFrom ? localDateFrom.isAfter(moment()) : false,
                        });
                    }
                } else {
                    form.setFieldsValue({
                        sheduledPublishDateFrom: null,
                        sheduledPublishDateTo: null,
                        title: '',
                        isSheduledPublishDate: false,
                    });
                }
            } finally {
                setIsLoading(false);
            }
        };

        initializePage();
    }, [onEdit, form, id]);



    const onFinish = (values: any) => {
        setLoadingButton(true);
        if (!onEdit) {// crear
            const data: NewsData = {
                id: newsInfo!.id,
                descriptionsByLanguage: newsInfo!.descriptionsByLanguage,
                titlesByLanguage: newsInfo!.titlesByLanguage,
                isFeatured: values.isFeatureNew,
                sheduleDayFrom: values.sheduledPublishDateFrom || moment().utc(),
                sheduleDayTo: values.sheduledPublishDateTo,
                status: "active",
                img: fileObj,
                imgName: fileObj?.name,
                imgContentType: fileObj?.type,
                base64Image: imageForUpload!
            }

            CreateNews(data, sessionData.userData.id).then((r) => {
                if (r?.type === 1) {
                    setIsThereAnyChange(false); // para que no se muestre el modal de borrador al salir
                    navigate(getNewsPath());
                }
                setLoadingButton(false);
            })

        } else { // editar
            // al editar, si la foto ya estÃ¡ subida y no ha cambiado, 
            //entonces tenemos el nombre guardado en imgName y imgContentType y base64Image es nulo
            // sino , subimos la foto 

            const data: NewsData = {
                id: newsInfo!.id,
                descriptionsByLanguage: newsInfo!.descriptionsByLanguage,
                titlesByLanguage: newsInfo!.titlesByLanguage,
                isFeatured: values.isFeatureNew,
                sheduleDayFrom: values.sheduledPublishDateFrom || moment().utc(),
                sheduleDayTo: values.sheduledPublishDateTo,
                status: "active",
                img: fileObj,
                imgName: fileObj?.name ? fileObj.name : imageForUpload,
                imgContentType: fileObj?.type,
                base64Image: fileObj?.name ? imageForUpload! : null
            }

            EditNews(data).then((r) => {
                if (r?.type === 1) {
                    setIsThereAnyChange(false); // para que no se muestre el modal de borrador al salir
                    navigate(getNewsPath());
                }
                setLoadingButton(false);
            })

        }

    };

    const onSaveDraft = async () => {
        try {
            await form.validateFields(['uploadFile', 'title', 'text']);
            setIsDraftModalFromBack(false);
            setIsVisibleDraftModal(true);
        } catch {
            // los errores se muestran inline en el formulario
        }
    };
    const onCancel = () => {
        navigate(getNewsPath());
    };

    const handleNavigateBack = () => {
        if (!isThereAnyChange) {
            navigate(getNewsPath());
        } else if (newsInfo?.status === "active") {
            setIsVisibleUnsavedModal(true);
        } else {
            setIsDraftModalFromBack(true);
            setIsVisibleDraftModal(true);
        }
    };

    const handleLanguageChange = (value: string) => {
        setSelectedLanguage(value);
    };


    const handleDescriptionChange = (content: string) => {
        setNewsInfo((prev) => {
            if (!prev) return null;

            // Verificar si descriptionsByLanguage ya contiene el idioma seleccionado
            const languageExists = prev.descriptionsByLanguage?.some(
                (lang) => lang.key === selectedLanguage
            );

            let updatedDescriptions;

            if (languageExists) {
                // Si existe, actualizar el valor correspondiente
                updatedDescriptions = prev.descriptionsByLanguage?.map((lang) =>
                    lang.key === selectedLanguage ? { ...lang, value: content } : lang
                );
            } else {
                // Si no existe, agregar un nuevo objeto para el idioma seleccionado
                updatedDescriptions = [
                    ...(prev.descriptionsByLanguage || []),
                    { key: selectedLanguage, value: content },
                ];
            }


            return { ...prev, descriptionsByLanguage: updatedDescriptions };
        });
    };


    const handleCheckboxChange = (checked: boolean) => {
        if (!checked) {
            form.setFieldsValue({ sheduledPublishDateFrom: null });
        }
    };
    const [isLoadingModal, setIsLoadingModal] = useState<boolean>(false);


    const changeNewStatus = async (id: string, isActive: boolean) => {
        setIsLoadingModal(true);
        try {
            const response = await ChangeNewsStatus(id, isActive);
            if (response?.type === 1) {
                const sheduleDay = isActive ? moment().utc() : null;
                form.setFieldValue("sheduledPublishDateFrom", sheduleDay);
                form.setFieldValue("sheduledPublishDateTo", !isActive ? null : newsInfo?.sheduleDayTo);
                form.setFieldValue("isSheduledPublishDate", false);
                setNewsInfo((prevNews: any) => {
                    if (!prevNews) return prevNews;
                    return {
                        ...prevNews,
                        status: isActive ? "active" : "inactive",
                        sheduleDayFrom: sheduleDay,
                    };
                });
            }
        } finally {
            setIsLoadingModal(false);
            setVisibleModalUnpublishedNews(false);
        }
    };


    const DeleteNews = async (id: string): Promise<void> => {
        const r = await deleteNews(id);
        if (r?.type === 1 && r?.data === true) {
            navigate(getNewsPath());
        }
    };


    const menu = (id: string, status: NewStatus) => (
        <Menu>
            <Menu.Item key="1" onClick={() => setVisibleModalDeleteNews(true)} icon={<DeleteOutlined />}>
                {t('components.communications.delete')}
            </Menu.Item>
            {status === "active" && (
                <Menu.Item key="4" onClick={() => setVisibleModalUnpublishedNews(true)} icon={<CloseCircleOutlined />}>
                    {t('components.communications.unpublish')}
                </Menu.Item>
            )}

        </Menu>
    );

    const ThreeDotsMenu = ({ id, status }: { id: string, status: NewStatus }) => (
        <Dropdown overlay={menu(id, status)} trigger={["click"]}>
            <Button type="text" icon={<MoreOutlined className="three-dots-icon" />} />
        </Dropdown>
    );


    const AllowedImagesType = "image/jpg,image/jpeg,image/png,image/svg";
    const MaxFileSizeMB = 2;
    const MinDimensions = { width: 300, height: 100 }; // Dimensiones mÃ­nimas
    const AspectRatioThreshold = 2.8; // Tolerancia de relaciÃ³n de aspecto



    const [imageForUpload, setImageForUpload] = useState<string | null>(null);
    const [fileObj, setFileObj] = useState<File | null>(null);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const beforeUpload = (file: File) => {

        const isAllowedType = AllowedImagesType.includes(file.type.split("/")[1]);
        const isUnder2MB = file.size / 1024 / 1024 < MaxFileSizeMB;
        if (!isAllowedType) {
            setErrorMessage(t("components.communications.bad-image-format") || "");
            return false;
        } else if (!isUnder2MB) {
            setErrorMessage(t("components.communications.bad-image-size") || "");
            return false;
        } else {
            setErrorMessage("");
        }
        return true;
    };

    const validateImageDimensions = (
        file: File,
        callback: (isValid: boolean) => void
    ) => {
        const img = new Image();
        img.onload = () => {
            const width = img.width;
            const height = img.height;

            // ValidaciÃ³n de dimensiones mÃ­nimas
            if (width < MinDimensions.width || height < MinDimensions.height) {
                setErrorMessage(
                    t("components.communications.form.min-dimmension") +
                    ` ${MinDimensions.width} x ${MinDimensions.height} px`
                );
                callback(false);
                return;
            }

            // ValidaciÃ³n de relaciÃ³n de aspecto
            const aspectRatio = width / height;
            const isPanoramic =
                Math.abs(aspectRatio - 3) <= AspectRatioThreshold; // RelaciÃ³n 3:1
            if (!isPanoramic || height > width) {
                setErrorMessage(
                    t("components.communications.form.invalid-aspect-ratio") || ""
                );
                callback(false);
                return;
            }

            callback(true);
        };

        img.onerror = () => {
            setErrorMessage(
                t("components.communications.error-processing-img") || ""
            );
            callback(false);
        };

        img.src = URL.createObjectURL(file);
    };

    const handleImgChange = (info: any) => {
        const file: File = info.file.originFileObj;

        validateImageDimensions(file, (isValid) => {
            if (!isValid) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                setImageForUpload(e.target?.result as string); // Guarda la imagen en base64
                setErrorMessage(""); // Limpiar errores al cargar correctamente
            };
            reader.readAsDataURL(file);

            setFileObj(file); // Guarda el archivo original
        });
    };



    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const title = event.target.value;
        setNewsInfo((prevNews) => {
            // Si no hay noticias previas, inicializamos el estado
            if (!prevNews) {
                return {
                    titlesByLanguage: [{ key: selectedLanguage, value: title }],
                } as NewsData;
            }

            // Verificamos si el idioma ya existe
            const languageExists = prevNews.titlesByLanguage.some(
                (language) => language.key === selectedLanguage
            );

            if (languageExists) {
                // Actualizamos el tÃ­tulo del idioma existente
                return {
                    ...prevNews,
                    titlesByLanguage: prevNews.titlesByLanguage.map((language) =>
                        language.key === selectedLanguage
                            ? { ...language, value: title }
                            : language
                    ),
                };
            }

            // Si el idioma no existe, lo aÃ±adimos
            return {
                ...prevNews,
                titlesByLanguage: [
                    ...prevNews.titlesByLanguage,
                    { key: selectedLanguage, value: title },
                ],
            };
        });
    };

    const handleDraft = async (): Promise<void> => {
        setIsLoadingModal(true);

        const data: NewsData = {
            id: newsInfo?.id || "",
            titlesByLanguage: newsInfo?.titlesByLanguage || [],
            descriptionsByLanguage: newsInfo?.descriptionsByLanguage || [],
            isFeatured: form.getFieldValue("isFeatureNew") || false,
            sheduleDayFrom: form.getFieldValue("sheduledPublishDateFrom"),
            sheduleDayTo: form.getFieldValue("sheduledPublishDateTo"),
            status: "draft",
            img: fileObj,
            imgName: fileObj?.name ? fileObj.name : imageForUpload,
            imgContentType: fileObj?.type,
            base64Image: fileObj?.name ? imageForUpload! : null,
        };

        await processDraft(data);
    };

    const processDraft = async (data: NewsData): Promise<void> => {
        try {
            let r;
            console.log("Processing draft with data:", data);
            if (!onEdit || id === null) {
                r = await CreateNews(data, sessionData.userData.id);
            } else {
                r = await EditNews(data);
            }

            if (r?.type === 1) {
                setIsThereAnyChange(false); // Para que no se muestre el modal de borrador al salir
                navigate(getNewsPath());
            }
        } finally {
            setIsLoadingModal(false);
            setIsVisibleDraftModal(false);
        }
    };



    const sheduledPublishDateFrom = (() => {
        if (!onEdit) {
            // Si es nuevo, la fecha por defecto es ahora
            return moment().utc();
        }
        if (newsInfo?.status === "inactive") {
            // Si no estÃ¡ activo, el valor es nulo
            return null;
        }
        // Devuelve la fecha programada desde `newsInfo`

        return moment.utc(newsInfo?.sheduleDayFrom).local();
    })();

    const handleValuesChange = () => {
        if (!isThereAnyChange && (newsInfo?.titlesByLanguage != undefined)) { // Solo se ejecuta si aÃºn no ha cambiado y si al menos hay un tÃ­tulo
            setIsThereAnyChange(true);
        }
    };

    const getNewsPath = () => {
        if (onEdit) {
            return window.location.pathname.replace(`/new/${id}`, ""); // Elimina "new/:id"
        } else {
            return window.location.pathname.replace(`/new`, ""); // Elimina "new"
        }
    };



    return (
        <div className="news-page">
            {isLoading && <LoadingData />}
            {!isLoading && (
                <Form
                    layout="vertical"
                    onFinish={onFinish}
                    form={form}
                    onValuesChange={handleValuesChange}
                    initialValues={{ sheduledPublishDateFrom: sheduledPublishDateFrom }}
                >
                    <GenericModal
                        isLoading={isLoadingModal && visibleModalUnpublishedNews}
                        title={t("components.communications.unpublish-new")}
                        visible={visibleModalUnpublishedNews}
                        onCancel={() => { setVisibleModalUnpublishedNews(false); }}
                        content={<div>{t("components.communications.unpublish-new-message")}</div>}
                        onOk={() => newsInfo && changeNewStatus(newsInfo.id, false)} />
                    <GenericModal
                        isLoading={isLoadingModal && visibleModalDeleteNews}
                        title={t("components.communications.delete-new")}
                        visible={visibleModalDeleteNews}
                        onCancel={() => { setVisibleModalDeleteNews(false); }}
                        content={<div>{t("components.communications.delete-new-message")}</div>}
                        onOk={async () => {
                            if (newsInfo) {
                                try {
                                    setIsLoadingModal(true);
                                    await DeleteNews(newsInfo.id);
                                    setVisibleModalDeleteNews(false);
                                } catch (error) {
                                    console.error("Error deleting news:", error);
                                } finally {
                                    setIsLoadingModal(false);
                                }
                            }
                        }}
                    />
                    <GenericModal
                        title={t("components.communications.draft-new")}
                        visible={isVisibleDraftModal}
                        isLoading={isLoadingModal}
                        onCancel={() => { setIsVisibleDraftModal(false); if (isDraftModalFromBack) navigate(getNewsPath()); }}
                        content={<div>{t("components.communications.draft-new-message")}</div>}
                        onOk={async () => { try { await handleDraft(); } finally { } }}
                    />
                    <GenericModal
                        title={t("components.communications.unsaved-changes")}
                        visible={isVisibleUnsavedModal}
                        isLoading={false}
                        onCancel={() => setIsVisibleUnsavedModal(false)}
                        content={<div>{t("components.communications.unsaved-changes-message")}</div>}
                        onOk={() => { setIsVisibleUnsavedModal(false); navigate(getNewsPath()); }}
                    />

                    {/* TOP BAR */}
                    <div className="np-topbar">
                        <div className="np-topbar__left">
                            <span className="np-back" onClick={handleNavigateBack}>
                                <ArrowLeftOutlined />{" "}{t("button.back-to-news")}
                            </span>
                            <h2 className="np-topbar__title">
                                {onEdit
                                    ? t("components.communications.edit")
                                    : t("components.communications.create-new")}
                            </h2>
                        </div>
                        {onEdit && newsInfo && (
                            <div className="np-topbar__meta">
                                <TagStatusNews status={newsInfo.status} sheduleDayFrom={newsInfo.sheduleDayFrom} sheduleDayTo={newsInfo.sheduleDayTo} />
                                {newsInfo?.status === "active" && (
                                    <span className="np-publish-date">
                                        {t("components.communications.news-will-be-publish")}
                                        {moment(newsInfo?.sheduleDayFrom).utc().format('DD/MM/YYYY')}
                                    </span>
                                )}
                                {newsInfo.isFeatured ? (
                                    <StarFilled
                                        className="np-star np-star--active"
                                        onClick={() =>
                                            EditFeaturedNews(newsInfo.id, false).then((res) => {
                                                if (res?.type === 1) {
                                                    setNewsInfo((prevNewsInfo: any) => ({
                                                        ...prevNewsInfo,
                                                        isFeatured: false,
                                                    }));
                                                }
                                            })
                                        }
                                    />
                                ) : (
                                    <StarOutlined
                                        className="np-star"
                                        onClick={() =>
                                            EditFeaturedNews(newsInfo.id, true).then((res) => {
                                                if (res?.type === 1) {
                                                    setNewsInfo((prevNewsInfo: any) => ({
                                                        ...prevNewsInfo,
                                                        isFeatured: true,
                                                    }));
                                                }
                                            })
                                        }
                                    />
                                )}
                                <ThreeDotsMenu id={newsInfo.id} status={newsInfo.status} />
                            </div>
                        )}
                    </div>

                    {/* EDITOR LAYOUT */}
                    <div className="np-layout">
                        {/* LEFT SIDEBAR */}
                        <div className="np-sidebar">
                            {/* Image card */}
                            <div className="np-card">
                                <div className="np-card__head">{t("components.communications.upload-image")}</div>
                                <Form.Item
                                    name="uploadFile"
                                    rules={[{
                                        validator() {
                                            if (!imageForUpload) {
                                                return Promise.reject(t("components.communications.form.image-required") ?? "");
                                            }
                                            return Promise.resolve();
                                        }
                                    }]}
                                >
                                    <Upload
                                        accept={AllowedImagesType}
                                        name="uploadFile"
                                        listType="picture"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        beforeUpload={beforeUpload}
                                        onChange={handleImgChange}
                                    >
                                        {imageForUpload ? (
                                            <span className="upload-container">
                                                <img src={imageForUpload} alt="upload" />
                                                <DeleteOutlined className="delete-icon" onClick={(e) => { e.stopPropagation(); setImageForUpload(""); form.validateFields(['uploadFile']); }} />
                                            </span>
                                        ) : (
                                            <div className="upload-container upload-placeholder">
                                                <PlusOutlined />
                                                <div>{t("components.communications.upload-image")}</div>
                                            </div>
                                        )}
                                    </Upload>
                                </Form.Item>
                                {errorMessage && <div className="np-img-error">{errorMessage}</div>}
                                <div className="np-img-hint">{t("components.communications.image-recommendations-size")}</div>
                                <div className="np-img-hint">{t("components.communications.image-recommendations")}</div>
                            </div>

                            {/* Scheduling card */}
                            <div className="np-card">
                                <div className="np-card__head">{t("components.communications.form.is-sheduled-publish-date")}</div>
                                <div className="checkbox-with-description">
                                    <Form.Item name="isSheduledPublishDate" valuePropName="checked" noStyle>
                                        <Checkbox onChange={(e) => handleCheckboxChange(e.target.checked)}>
                                            {t("components.communications.form.is-sheduled-publish-date")}
                                        </Checkbox>
                                    </Form.Item>
                                    <span className="description">
                                        {t("components.communications.form.is-sheduled-publish-date-description")}
                                    </span>
                                </div>
                                <Form.Item
                                    label={t("components.communications.form.sheduled-publish-date-from")}
                                    name="sheduledPublishDateFrom"
                                    rules={[
                                        {
                                            validator(_, value) {
                                                if (isScheduled && !value) {
                                                    return Promise.reject(
                                                        t("components.communications.form.sheduled-publish-date-from") || "Selecciona una fecha de publicación"
                                                    );
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        disabled={!isScheduled}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t("components.communications.form.sheduled-publish-date-to")}
                                    name="sheduledPublishDateTo"
                                    dependencies={["sheduledPublishDateFrom"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const fromDate = getFieldValue("sheduledPublishDateFrom");
                                                if (value && fromDate && value.isBefore(fromDate)) {
                                                    return Promise.reject(
                                                        t("components.communications.form.sheduled-publish-date-to-error") || ""
                                                    );
                                                }
                                                return Promise.resolve();
                                            },
                                        }),
                                    ]}
                                >
                                    <DatePicker format="YYYY-MM-DD" />
                                </Form.Item>
                            </div>

                            {/* Featured card â€” only when creating */}
                            {!onEdit && (
                                <div className="np-card">
                                    <div className="np-card__head">{t("components.communications.form.is-featured-new")}</div>
                                    <Form.Item name="isFeatureNew" valuePropName="checked">
                                        <div className="checkbox-with-description">
                                            <Checkbox>{t("components.communications.form.is-featured-new")}</Checkbox>
                                            <span className="description">
                                                {t("components.communications.form.is-featured-new-description")}
                                            </span>
                                        </div>
                                    </Form.Item>
                                </div>
                            )}
                        </div>

                        {/* RIGHT MAIN AREA */}
                        <div className="np-main">
                            <div className="np-card">
                                <div className="np-lang-title-row">
                                    <Form.Item label={t("components.communications.form.language")} name="language" className="np-lang-field">
                                        <LanguageSelectorNews
                                            languages={availableLanguages}
                                            selectedLanguage={selectedLanguage}
                                            onLanguageChange={handleLanguageChange}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t("components.communications.form.title")}
                                        name="title"
                                        className="np-title-field"
                                        rules={[
                                            {
                                                validator: () => {
                                                    if (
                                                        !newsInfo?.titlesByLanguage ||
                                                        newsInfo.titlesByLanguage.every((item) => !item.value.trim())
                                                    ) {
                                                        return Promise.reject(t("components.communications.form.title-required"));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <Input
                                            value={newsInfo?.titlesByLanguage.find((lang) => lang.key === selectedLanguage)?.value || ''}
                                            onChange={handleTitleChange}
                                        />
                                    </Form.Item>
                                </div>
                            </div>

                            <Form.Item
                                name="text"
                                rules={[
                                    {
                                        validator: () => {
                                            if (
                                                !newsInfo?.descriptionsByLanguage ||
                                                newsInfo.descriptionsByLanguage.every((item) => !item.value.trim())
                                            ) {
                                                return Promise.reject(t("components.communications.form.description-required"));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <TinyEditor
                                    content={newsInfo?.descriptionsByLanguage?.find((lang) => lang.key === selectedLanguage)?.value || ''}
                                    setContent={handleDescriptionChange}
                                />
                            </Form.Item>
                            <div className="np-footer">
                                <Button className="np-btn-cancel" onClick={onCancel}>
                                    {t("button.cancel")}
                                </Button>
                                {(!onEdit || (onEdit && newsInfo?.status !== "active")) && (
                                    <Button className="np-btn-draft" disabled={!isThereAnyChange} onClick={onSaveDraft}>
                                        {t("button.save-drift")}
                                    </Button>
                                )}
                                <Form.Item style={{ margin: 0 }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={loadingButton}
                                        className="app-button"
                                    >
                                        {loadingButton ? (
                                            <>
                                                <LoadingOutlined /> {t((onEdit && newsInfo?.status !== "draft") ? "button.editing" : "button.publishing")}
                                            </>
                                        ) : (
                                            t((onEdit && newsInfo?.status !== "draft") ? "button.edit" : "button.publish")
                                        )}
                                    </Button>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </div>
    );
};

export default NewsPage;

